import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet-async';
import { getPrimaryProductImage } from '../utils/productImages';

function CartPage() {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, clearCart, updateQuantity, cartTotal } = useCart();

  const handleCheckout = () => {
    navigate('/checkout', { state: { cartItems } });
  };

  return (
    <div className="cart-page">
      <Helmet>
        <title>Your Cart – Hercles Global</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header backTo="/" backLabel="← Continue Shopping" />

      <div className="cart-page-inner">
        <h1 className="cart-page-title">Your Cart</h1>

        {cartItems.length === 0 ? (
          <div className="cart-page-empty">
            <p>Your cart is empty.</p>
            <Link to="/" className="order-btn" style={{ textDecoration: 'none', display: 'inline-block', marginTop: 16 }}>
              Browse Products
            </Link>
          </div>
        ) : (
          <>
            <div className="cart-page-items">
              {cartItems.map(item => {
                const img = getPrimaryProductImage(item);
                return (
                <div key={item.id} className="cart-page-item">
                  {img
                    ? <img src={img} alt={item.name} className="cart-page-item-img" />
                    : <div className="cart-page-item-img cart-page-no-img" />
                  }
                  <div className="cart-page-item-info">
                    <p className="cart-page-item-name">{item.name}</p>
                    <p className="cart-page-item-unit">KES {parseFloat(item.price).toLocaleString('en-KE', {minimumFractionDigits:2, maximumFractionDigits:2})} each</p>
                  </div>
                  <div className="cart-page-qty">
                    <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>−</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                  </div>
                  <p className="cart-page-item-subtotal">
                    KES {(parseFloat(item.price) * item.quantity).toLocaleString('en-KE', {minimumFractionDigits:2, maximumFractionDigits:2})}
                  </p>
                  <button
                    className="cart-page-remove"
                    onClick={() => removeFromCart(item.id)}
                    aria-label="Remove item"
                  >
                    ✕
                  </button>
                </div>
                );
              })}
            </div>

            <div className="cart-page-footer">
              <button className="cart-clear-btn" onClick={clearCart}>
                Clear Cart
              </button>
              <div className="cart-page-summary">
                <div className="cart-page-total-row">
                  <span>Subtotal</span>
                  <span>KES {cartTotal.toLocaleString('en-KE', {minimumFractionDigits:2, maximumFractionDigits:2})}</span>
                </div>
                <div className="cart-page-total-row">
                  <span>Shipping</span>
                  <span>Free</span>
                </div>
                <div className="cart-page-total-row total">
                  <span>Total</span>
                  <span>KES {cartTotal.toLocaleString('en-KE', {minimumFractionDigits:2, maximumFractionDigits:2})}</span>
                </div>
                <button className="order-btn cart-checkout-btn" onClick={handleCheckout}>
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default CartPage;
